import { IconSymbol } from '../iconBuilder';

export const WINDOW_ICON: IconSymbol = {
    name: 'Siding',
    path: 'M32 256V64C32 28.7 60.7 0 96 0H416c35.3 0 64 28.7 64 64V256 448c17.7 0 32 14.3 32 32s-14.3 32-32 32H416 96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V256zm384 32H280V448H416V288zm-184 0H96V448H232V288zm48-64H416V64H280V224zM232 64H96V224H232V64z',
    tx: 5,
    ty: 0,
};
